import PageHeader from "../../components/PageHeader";
import { Button, Container, Paper, Stack, TextField } from "@mui/material";
import { ChangeEvent, useState } from "react";
import { UserService } from "../../api/psc.ts";
import { useNavigate } from "react-router-dom";

export default function CreateUser() {
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [requestInProgress, setRequestInProgress] = useState(false);

    const handleUsernameChange = (event: ChangeEvent<HTMLInputElement>) => {
        setUsername(event.target.value);
    };

    const handleFirstNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        setFirstName(event.target.value);
    };

    const handleLastNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        setLastName(event.target.value);
    };

    const handleMobileNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
        setMobileNumber(event.target.value);
    };

    const submit = () => {
        setRequestInProgress(true);
        UserService.createUser({
            lastName,
            firstName,
            username,
            mobileNumber,
        }).then((r) => {
            navigate("/");
        });
    };

    return (
        <Container maxWidth="xs">
            <PageHeader title="ایجاد کاربر" />

            <Paper sx={{ p: 2 }}>
                <Stack spacing={2}>
                    <TextField
                        label="نام کاربری"
                        value={username}
                        onChange={handleUsernameChange}
                    />
                    <TextField
                        label="نام"
                        value={firstName}
                        onChange={handleFirstNameChange}
                    />
                    <TextField
                        label="نام خانوادگی"
                        value={lastName}
                        onChange={handleLastNameChange}
                    />
                    <TextField
                        label="شماره موبایل"
                        value={mobileNumber}
                        onChange={handleMobileNumberChange}
                    />

                    <Button
                        disabled={requestInProgress}
                        onClick={submit}
                        variant="contained"
                    >
                        ایجاد کاربر
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
}
